import { useState, useRef, useEffect, useCallback } from 'react';

// Terminal-style text decode: on play(), the string boils with random
// glyphs and resolves left→right to the real text (~30ms per character).
// No-op under prefers-reduced-motion; layout is stable in monospace since
// length never changes.

const CHARSET = '01<>/{}[]#$%&*+=_';

export function useScramble(text, step = 28) {
  const [display, setDisplay] = useState(text);
  const rafRef = useRef(0);
  const runningRef = useRef(false);

  useEffect(() => { setDisplay(text); }, [text]);
  useEffect(() => () => cancelAnimationFrame(rafRef.current), []);

  const play = useCallback(() => {
    if (runningRef.current || !text) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    runningRef.current = true;
    const start = performance.now();
    const frame = (now) => {
      const resolved = (now - start) / step;
      if (resolved >= text.length) {
        setDisplay(text);
        runningRef.current = false;
        return;
      }
      let out = '';
      for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        out += (ch === ' ' || i < resolved)
          ? ch
          : CHARSET[Math.floor(Math.random() * CHARSET.length)];
      }
      setDisplay(out);
      rafRef.current = requestAnimationFrame(frame);
    };
    rafRef.current = requestAnimationFrame(frame);
  }, [text, step]);

  return [display, play];
}
